import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';

const ArtigosSidebar = ({ onOptionChange }) => {
    const items = [
        {
            label: 'Criar artigo',
            icon: 'pi pi-plus',
            command: () => onOptionChange('criar')
        },
        {
            label: 'Ver artigos',
            icon: 'pi pi-eye',
            items: [
                {
                    label: 'Por família',
                    icon: 'pi pi-tags',
                    command: () => onOptionChange('porFamilia')
                },
                {
                    label: 'Por referência',
                    icon: 'pi pi-info-circle',
                    command: () => onOptionChange('porReferencia')
                },
                {
                    label: 'Por Fornecedor',
                    icon: 'pi pi-briefcase',
                    command: () => onOptionChange('porFornecedor')
                }
            ]
        }
    ];

    return (
        <div className="p-3">
            <PanelMenu model={items} style={{ width: '100%' }} />
        </div>
    );
};

export default ArtigosSidebar;
